export default __webpack_public_path__ + "static/media/skimatic-filter.84f635b1.png";